
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.98 14A6.98 6.98 0 012.045 2.084a6.98 6.98 0 119.87 9.871A6.934 6.934 0 016.98 14zM3.997 9.601v1.027h6.423V9.603l-6.423-.002zM2.889 4.62l1.136 2.997V9.34h6.402V7.573l.957-2.921L8.6 5.73 7.14 3.41l-1.58 2.436-2.67-1.227z","fill":"#FF9D0B"}})])
          )
        }
      }
    